import { Button, Dialog, DialogActions, DialogContent, IconButton } from '@material-ui/core';
import CloseIcon from '@material-ui/icons/Close';
import { onHandlerDeleteView } from '../handler/ViewHandler';
import { tr } from '@/common/utils/tr';
import { useTranslationSubscription } from '@/hooks/useTranslation';

export const DialogConfirmDeleteView = (props) => {
    // Re-render when the translation dictionary loads/extends so tr() text updates.
    useTranslationSubscription();

    const onCloseConfirm = (event, reason) => {
        if (event && reason === 'backdropClick') {
            return false;
        }

        props.setIsConfirmDeleteView(false);
    };

    return (
        <Dialog
            open={props.isConfirmDeleteView}
            onClose={(event, reason) => onCloseConfirm(event, reason)}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
            className="wrapDialog"
        >
            <DialogContent>
                <div className="confirm-dialog-content">
                    {tr('ビューを削除して宜しいでしょうか？')}
                    <IconButton
                        className="close"
                        onClick={(event, reason) => onCloseConfirm(event, reason)}
                    >
                        <CloseIcon />
                    </IconButton>
                </div>
            </DialogContent>
            <DialogActions className="confirm-dialog-action">
                <Button className="confirm-dialog-button" variant="contained" color="primary" onClick={() => onHandlerDeleteView(props.view, props)}>
                    {tr('はい')}
                </Button>
                <Button
                    className="confirm-dialog-button"
                    variant="contained"
                    color="primary"
                    onClick={(event, reason) => onCloseConfirm(event, reason)}
                >
                    {tr('いいえ')}
                </Button>
            </DialogActions>
        </Dialog>
    );
};
